import React from 'react';
import './contact.css';

const Contact = () => {
  return (
    <div id='contact'>
      <span>

      <h1>Contact Information </h1>
        <div className='contactItem'>

          <div className= 'contact-details'>

          <ul>
            <li>
              <div className='icons'>
                <i className='fas fa-home '></i>
              </div>
              <div className= 'texts'>
                <p>
                  ManSysCo Pty Ltd<br />
                  52 Lady Game Drive<br />
                  Killara, 2071<br />
                  New South Wales<br />
                  AUSTRALIA<br />
                </p>
              </div>
            </li>
            <li>
              <div className='icons'>
                <i className='fas fa-phone'></i>
              </div>
              <div className= 'texts'>
                <p>
                <a href='tel:+610415648079'>+61-(0)415-648-079</a>
                </p>
                <p>9am to 5pm/ Mon-Fri</p>
              </div>
            </li>
            <li>
              <div className='icons'>
                <i className='fas fa-envelope'></i>
              </div>
              <div className= 'texts'>
                <p>info@mansysco.com</p>
              </div>
            </li>
            {/* <li>
              <span></span>
              <span className= 'texts'>
                <p>9am-5pm, Mon-Fri</p>
              </span>
            </li> */}
          </ul>
          </div>

          <form 
            action= 'https://smtp-inquiry-mansysco.herokuapp.com/mail'
            method= 'post'
            className= 'contact_form'
          >
            <input 
              className= 'cells' 
              name= 'firstName' 
              type='text' 
              placeholder= '* First Name' 
              required
            ></input>
            <input 
              className= 'cells' 
              name= 'lastName' 
              type='text' 
              placeholder= '* Last Name' 
              required
            ></input>
            <input 
              className= 'cells' 
              name= 'email' 
              type='email' 
              placeholder= '* Email address' 
              required
            ></input>
            <input 
              className= 'cells' 
              name= 'phone'
              type='tel' 
              placeholder= '* Phone Number' 
            ></input>
            <textarea 
              name='comment'
              type='text'
              placeholder= 'Messages here'>
            </textarea>
            <input 
              type='submit' 
              value= 'Send'
              className='submit_btn'
            ></input>
          </form>

        </div>
      </span>
    </div>
  );
};

export default Contact;